<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الاسم - عربي:</label>
            <input type="text" v-model="name" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الاسم - إنجليزي:</label>
            <input type="text" v-model="nameEn" class="form-control english-input">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">السعر:</label>
            <input type="number" v-model="price" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحالة:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">نشط</option>
              <option :value="false">غير نشط</option>
            </select>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'PropertyBannerSizesForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      name: '',
      nameEn: '',
      price: 0,
      isActive: true,
    }
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(
        !this.name || this.name.trim() == '' || !this.nameEn || this.nameEn.trim() == '' || !this.price
      ){
        this.message = 'كل الحقول مطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return false;
      }
      let payload = {
        name: this.name,
        nameEn: this.nameEn,
        price: this.price ?? 0,
        isActive: this.isActive,
      }
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/propertyBanners/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/propertyBanners/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/propertyBannerSizes').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.nameEn = this.dataRow.nameEn;
      this.price = this.dataRow.price;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
